// extracted by mini-css-extract-plugin
module.exports = {"totalCases":"TotalCases_totalCases__2M3T6","totalConfirmed":"TotalCases_totalConfirmed__1AUUc","updated":"TotalCases_updated__3J2iY"};